const MIN_SPINNER_MS = 750

export default function useServerWait({ onClick, saveButton, setSaving, isSaving }) {
  const [succeeded, setSucceeded] = useState(false)
  const timeoutRef = useRef(null)
  const successTimeoutRef = useRef(null)
  const savingRef = useRef(isSaving)
  const startTimeRef = useRef(null)

  function doAction() {
    if (savingRef.current) {
      timeoutRef.current = setTimeout(doAction, 100)
    } else {
      setSaving(true)
      startTimeRef.current = Date.now()
      onClick().then(() => {
        const finish = () => {
          setSaving(false)
          if (saveButton) {
            setSucceeded(true)
            successTimeoutRef.current = setTimeout(() => setSucceeded(false), 3000)
          }
        }
        if (saveButton) {
          const remaining = MIN_SPINNER_MS - (Date.now() - startTimeRef.current)
          if (remaining > 0) {
            timeoutRef.current = setTimeout(finish, remaining)
          } else {
            finish()
          }
        } else {
          finish()
        }
      }).catch(() => {
        setSaving(false)
      })
    }
  }

  useEffect(() => {
    savingRef.current = isSaving
  }, [isSaving])

  useEffect(() => () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    if (successTimeoutRef.current) clearTimeout(successTimeoutRef.current)
  }, [])

  return { doAction, succeeded }
}
